import { defineStore } from "pinia";

/**
 * Represents the state managment for notifications
 */
export const useNotificationStore = defineStore('notifications', {
    state: () => ({
        count_un_read: 0, // number of unread notifications
        notif_list: [] as any[] // list of notifications
    }),
    getters: {
        getCountUnread: (state) => state.count_un_read,
        getNotifList: (state) => state.notif_list
    },
    actions: {
        setCountUnread(value: number) {
            this.count_un_read = value
        },
        setNotifList(value: any[]) {
            this.notif_list = value
        }
    }
})